import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config'

const REQUEST_ENTRIES = 'REQUEST_ENTRIES'
const RECEIVE_ENTRIES = 'RECEIVE_ENTRIES'
const RECEIVE_ENTRY = 'RECEIVE_ENTRY'
const SUBMIT_VOTE = 'SUBMIT_VOTE'
const SEND_VOTE = 'SEND_VOTE'

const initialState = {
  entries: [],
  entry: null,
  requestLoading: false,
  hasVoted: false,
}

export default function entryReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_ENTRIES:
      return {
        ...state,
        entries: null,
        requestLoading: true,
      }

    case SEND_VOTE:
      return {
        ...state,
        requestLoading: true,
      }

    case RECEIVE_ENTRIES:
      return {
        ...state,
        entries: action.entries,
        requestLoading: false
      }

    case RECEIVE_ENTRY:
      return {
        ...state,
        entry: action.entry,
        requestLoading: false
      }
    case SUBMIT_VOTE:
      return {
        ...state,
        hasVoted: action.hasVoted,
        requestLoading: false
      }

    default:
      return state
  }
}

export function getEntries() {
  return (dispatch) => {
    dispatch(requestEntries())

    return axios
      .get(`${config.apiUrl}/api/entries`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success) {
          dispatch(receiveEntries(data.entries))
          dispatch(votingStatus(data.hasVoted))
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
      })
  }
}


export function getEntry(entryId) {
  return (dispatch) => {
    return axios
      .get(`${config.apiUrl}/api/entries/${entryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success) {
          dispatch(receiveEntry(data.entry))
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
      })
  }
}
export function submitVotes(payload) {
  return (dispatch) => {
    dispatch(sendingVote())

    return axios
      .post(`${config.apiUrl}/api/entry_votes`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        dispatch(votingStatus(data.success))
        if (!data.success) {
          toast(data.error)
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
      })
  }
}


function requestEntries() {
  return {
    type: REQUEST_ENTRIES,
  }
}
function sendingVote() {
  return {
    type: SEND_VOTE,
  }
}
function receiveEntries(entries) {
  return {
    type: RECEIVE_ENTRIES,
    entries,
  }
}

function receiveEntry(entry) {
  return {
    type: RECEIVE_ENTRY,
    entry,
  }
}

function votingStatus(hasVoted) {
  return {
    type: SUBMIT_VOTE,
    hasVoted
  }
}
